import { createNewElement } from "../utils/functions";

const pageHomeSlider = () => {
  // Format Home Page Slider Slides
  if (document.body.classList.contains("home-page")) {
    setInterval(() => {
      const slider = document.querySelector(".home-slider-section");
      if (slider) {
        const sliderCheck = slider.querySelector(".slide-wrapper");

        if (!sliderCheck) {
          const slides = document.querySelectorAll(".slideshow__link");
          formatSlides(slides);

          // Classi Slides
          slides.forEach((slide) => {
            const title = slide.querySelector(".slide-title").innerHTML;
            if (title.includes("Limited Edition")) {
              slide.classList.add("pettegola-slide");
            }
            if (title.includes("Natale") || title.includes("Christmas")) {
              slide.classList.add("christmas-slide");
            }
          });
        }
      }

      const sliderMobile = document.querySelector(".home-mobile-slider-section");
      if (sliderMobile) {
        const sliderMobileCheck = sliderMobile.querySelector(".slide-wrapper");
        if (!sliderMobileCheck) {
          const slidesMobile = sliderMobile.querySelectorAll(".slideshow__link");
          formatSlides(slidesMobile);

          // Pettegola Slide
          slidesMobile.forEach((slide) => {
            const title = slide.querySelector(".slide-title").innerHTML;
            if (title.includes("Limited Edition")) {
              slide.classList.add("pettegola-slide-mobile");
            }
          });
        }
      }
    }, 100);
  }
};

export default pageHomeSlider;

/**
 * Format Slides
 *
 * @param array slides
 */

const formatSlides = (slides) => {
  if (slides) {
    slides.forEach((slideLink) => {
      const slideWrapper = document.createElement("div"),
        title = slideLink.querySelector(".slideshow-slide__title"),
        text = slideLink.querySelector(".slideshow-slide__text"),
        titleContent = title ? title.innerHTML : "",
        textContent = text ? text.innerHTML : "",
        lang = document.getElementsByTagName("html")[0].getAttribute("lang"),
        btnLabel = lang === "it" ? "Acquista" : "Buy";

      slideWrapper.classList.add("slide-wrapper");

      slideWrapper.append(createNewElement("h2", ["slide-title"], titleContent));
      slideWrapper.append(createNewElement("p", ["slide-text"], textContent));
      slideWrapper.append(createNewElement("div", ["slide-btn"], btnLabel));

      slideLink.append(slideWrapper);
    });
  } else {
    console.log("Missing params in function formatSlides(slides)", [slides]);
  }
};
